/** PDF page dimensions (points) */
export type PageSizeSetting = 'auto' | 'a4' | 'letter';
export type OrientationSetting = 'auto' | 'portrait' | 'landscape';

const A4_W = 595.28;
const A4_H = 841.89;
const LETTER_W = 612;
const LETTER_H = 792;

export interface PageDims {
  widthPt: number;
  heightPt: number;
}

export function basePaperPts(pageSize: Exclude<PageSizeSetting, 'auto'>): PageDims {
  if (pageSize === 'letter') return { widthPt: LETTER_W, heightPt: LETTER_H };
  return { widthPt: A4_W, heightPt: A4_H };
}

/**
 * Resolves output page dimensions in portrait or landscape.
 * Auto orientation uses landscape for wide images when width exceeds height.
 */
export function resolvePageDimensions(
  pageSize: PageSizeSetting,
  orientation: OrientationSetting,
  hint?: { kind: 'image' | 'document'; widthPx?: number; heightPx?: number },
): PageDims {
  const paperKind = pageSize === 'letter' ? 'letter' : 'a4';
  let { widthPt: w, heightPt: h } = basePaperPts(paperKind);

  let landscape = false;
  if (orientation === 'landscape') landscape = true;
  else if (orientation === 'portrait') landscape = false;
  else if (hint?.kind === 'image' && hint.widthPx && hint.heightPx) {
    landscape = hint.widthPx > hint.heightPx;
  }

  if (landscape) {
    return w >= h ? { widthPt: w, heightPt: h } : { widthPt: h, heightPt: w };
  }
  return w <= h ? { widthPt: w, heightPt: h } : { widthPt: h, heightPt: w };
}
